import { BadgeCheck } from "lucide-react";

/**
 * Small pill shown next to a user's name whenever they hold an active
 * "Certified Beta Reader" status. Reads the ``is_certified`` boolean +
 * optional ``cert_genres`` array that ``/api/users/*`` endpoints now
 * enrich server-side.
 */
export default function CertifiedBadge({
  isCertified,
  genres,
  size = "md",
  showGenres = false,
  className = "",
}) {
  if (!isCertified) return null;
  // Sizing tiers:
  //  - "sm"  : compact — used in search / list cards where space is tight.
  //  - "md"  : default — profile headers. Small on mobile so it can sit
  //            next to a long display_name; slightly larger on desktop so
  //            it doesn't get lost next to a `text-3xl md:text-4xl` heading
  //            and the "· genres" trailer stays legible.
  const sizing =
    size === "sm"
      ? "text-[10px] px-1.5 py-0.5 gap-1"
      : "text-[11px] px-2 py-0.5 gap-1 md:text-xs md:px-2.5 md:py-1 md:gap-1.5";
  const iconSize = size === "sm" ? 10 : 12;
  return (
    <span
      className={`inline-flex items-center rounded-full whitespace-nowrap border-2 border-[hsl(var(--sb-gold-2))] bg-[hsl(var(--sb-gold)/0.5)] text-[hsl(var(--sb-gold-2))] font-semibold dark:bg-[hsl(var(--sb-gold-2))] dark:text-[hsl(40_60%_96%)] dark:border-[hsl(var(--sb-gold-2))] ${sizing} ${className}`}
      data-testid="certified-badge"
      title="Last Bookmark Certified — reviewed by Last Bookmark based on the reader's application and sample. Not an industry credential."
    >
      <BadgeCheck size={iconSize} strokeWidth={2.4} />
      <span>Certified</span>
      {showGenres && Array.isArray(genres) && genres.length > 0 && (
        <span className="opacity-80 truncate max-w-[10rem]">
          · {genres.slice(0, 2).join(", ")}
          {genres.length > 2 ? "…" : ""}
        </span>
      )}
    </span>
  );
}
